import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'mobile-app-testing-notification',
    template: `
<div class="appId" *ngIf="!!appId">
App Id: {{ appId }}
</div>
<div class="invalid" *ngIf="!fromFlutter">
  Cannot register a device from the web
</div>
<div class="register" *ngIf="fromFlutter">
  Click below to register this device
</div>

`,
    styleUrls: ['./mobile-app-notifications.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class MobileAppTestingRegistrationComponent {
  get fromFlutter() { return window.fromFlutter }
  appId: string

  constructor(private route: ActivatedRoute) {
    this.route.paramMap.subscribe( paramMap => {
      this.appId = paramMap.get('id')
    })
  }
}

